import dayjs from "dayjs"
import Footer from "../../components/marketing/footer/Footer"
import MarketingBanner from "../../components/Banner/MarketingBanner"
import MarketingNav from "../../components/navigation/MarketingNav"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"
import { Outlet } from "react-router-dom"

dayjs.extend(utc)
dayjs.extend(timezone)

interface Props {
  guideOpened: any
  setGuideOpened: any
}

const MarketingLayout: React.FC<Props> = ({ guideOpened, setGuideOpened }) => {
  // cut off so we don't have to keep removing and adding in banners.
  //  date and time in eastern time
  const cutoff = dayjs.tz("2026-01-01 00:00", "America/New_York")
  const now = dayjs().tz("America/New_York")
  const showBanner = now.isBefore(cutoff)

  return (
    <>
      {showBanner && <MarketingBanner />}
      <MarketingNav guideOpened={guideOpened} setGuideOpened={setGuideOpened} />
      <Outlet />
      <Footer />
    </>
  )
}

export default MarketingLayout
